var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.el,_vm._g(_vm._b({tag:"components",staticClass:"animated-number"},'components',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v(_vm._s(_vm.animatedNumber))],{"value":_vm.animatedNumber})],2)}
var staticRenderFns = []

export { render, staticRenderFns }